/** URL del backend Express (solo server-side o fallback build). */
export function getBackendUrl(): string {
  const url =
    process.env.BACKEND_URL ||
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    "http://localhost:5050";
  return url.replace(/\/+$/, "");
}

/** Base path same-origin per richieste autenticate dal browser. */
export const BROWSER_API_PREFIX = "/api/backend";
